import { render, staticRenderFns } from "./SpanEdit.vue?vue&type=template&id=3ccb26e4"
import script from "./SpanEdit.vue?vue&type=script&lang=js"
export * from "./SpanEdit.vue?vue&type=script&lang=js"
import style0 from "./SpanEdit.vue?vue&type=style&index=0&id=3ccb26e4&prod&style=scss&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports